export const mockMarketplaceFilterData = [
  {
    id: 'Type',
    title: 'Core_Type',
    subitems: [
      {
        title: 'Course',
        model: {
          id: 'course',
          name: 'Course',
          count: 143645,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Article',
        model: {
          id: 'article',
          name: 'Article',
          count: 81613,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Book',
        model: {
          id: 'book',
          name: 'Book',
          count: 51291,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Video',
        model: {
          id: 'video',
          name: 'Video',
          count: 37226,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Event',
        model: {
          id: 'event',
          name: 'Event',
          count: 2959,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Podcast',
        model: {
          id: 'episode',
          name: 'Episode',
          count: 1062,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Plans and Directories',
        model: {
          id: 'target',
          name: 'Target',
          count: 863,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Assessment',
        model: {
          id: 'assessment',
          name: 'Assessment',
          count: 836,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Pathway',
        model: {
          id: 'pathway',
          name: 'Pathway',
          count: 640,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
    ],
  },
  {
    id: 'Language',
    title: 'Core_Language',
    subitems: [
      {
        title: 'English',
        model: {
          id: 'en',
          name: 'English',
          count: 258341,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'español',
        model: {
          id: 'es',
          name: 'español',
          count: 4213,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'português',
        model: {
          id: 'pt',
          name: 'português',
          count: 1524,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'français',
        model: {
          id: 'fr',
          name: 'français',
          count: 1182,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'العربية',
        model: {
          id: 'ar',
          name: 'العربية',
          count: 837,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Deutsch',
        model: {
          id: 'de',
          name: 'Deutsch',
          count: 508,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '中文',
        model: {
          id: 'zh',
          name: '中文',
          count: 472,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '日本語',
        model: {
          id: 'ja',
          name: '日本語',
          count: 285,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'русский',
        model: {
          id: 'ru',
          name: 'русский',
          count: 261,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Indonesia',
        model: {
          id: 'id',
          name: 'Indonesia',
          count: 214,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'italiano',
        model: {
          id: 'it',
          name: 'italiano',
          count: 206,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '한국어',
        model: {
          id: 'ko',
          name: '한국어',
          count: 150,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'polski',
        model: {
          id: 'pl',
          name: 'polski',
          count: 89,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'čeština',
        model: {
          id: 'cs',
          name: 'čeština',
          count: 75,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Nederlands',
        model: {
          id: 'nl',
          name: 'Nederlands',
          count: 74,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Türkçe',
        model: {
          id: 'tr',
          name: 'Türkçe',
          count: 48,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Tiếng Việt',
        model: {
          id: 'vi',
          name: 'Tiếng Việt',
          count: 32,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'हिंदी',
        model: {
          id: 'hi',
          name: 'हिंदी',
          count: 27,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'Aghem',
        model: {
          id: 'agq',
          name: 'Aghem',
          count: 26,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'עברית',
        model: {
          id: 'he',
          name: 'עברית',
          count: 26,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: 'None',
        model: {
          id: 'missing',
          name: 'None',
          count: 51420,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
    ],
  },
  {
    id: 'Provider',
    title: 'Core_Provider',
    subitems: [
      {
        title: "O'Reilly",
        model: {
          id: '30',
          name: "O'Reilly",
          count: 58408,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/30',
        },
        isSelected: false,
      },
      {
        title: 'Degreed',
        model: {
          id: '-1',
          name: 'Degreed',
          count: 56949,
          score: 0,
          filter: false,
          baseUrl: 'http://wiki.degreed.com',
        },
        isSelected: false,
      },
      {
        title: 'Coursera',
        model: {
          id: '7',
          name: 'Coursera',
          count: 35465,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/7',
        },
        isSelected: false,
      },
      {
        title: 'Pluralsight',
        model: {
          id: '14',
          name: 'Pluralsight',
          count: 16112,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/14',
        },
        isSelected: false,
      },
      {
        title: 'HBP LeadingEdge',
        model: {
          id: '2080',
          name: 'HBP LeadingEdge',
          count: 11760,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2080',
        },
        isSelected: false,
      },
      {
        title: 'Skillshare',
        model: {
          id: '17',
          name: 'Skillshare',
          count: 8989,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/17',
        },
        isSelected: false,
      },
      {
        title: 'Cornerstone OnDemand',
        model: {
          id: '2068',
          name: 'Cornerstone OnDemand',
          count: 7022,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2068',
        },
        isSelected: false,
      },
      {
        title: 'CE Direct',
        model: {
          id: '2094',
          name: 'CE Direct',
          count: 3733,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2094',
        },
        isSelected: false,
      },
      {
        title: 'Workday',
        model: {
          id: '3461',
          name: 'Workday',
          count: 2310,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/3461',
        },
        isSelected: false,
      },
      {
        title: 'Tuts+',
        model: {
          id: '912',
          name: 'Tuts+',
          count: 1270,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/912',
        },
        isSelected: false,
      },
      {
        title: 'tersdteee',
        model: {
          id: '2463',
          name: 'tersdteee',
          count: 1238,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2463',
        },
        isSelected: false,
      },
      {
        title: 'Saba',
        model: {
          id: '2056',
          name: 'Saba',
          count: 1022,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2056',
        },
        isSelected: false,
      },
      {
        title: 'Percipio',
        model: {
          id: '2419',
          name: 'Percipio',
          count: 999,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2419',
        },
        isSelected: false,
      },
      {
        title: 'Vodeclic',
        model: {
          id: '978',
          name: 'Vodeclic',
          count: 646,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/978',
        },
        isSelected: false,
      },
      {
        title: 'SuccessFactors',
        model: {
          id: '2111',
          name: 'SuccessFactors',
          count: 603,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2111',
        },
        isSelected: false,
      },
      {
        title: 'intheDC',
        model: {
          id: '2135',
          name: 'intheDC',
          count: 413,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2135',
        },
        isSelected: false,
      },
      {
        title: 'SuccessFactorsFR',
        model: {
          id: '2300',
          name: 'SuccessFactorsFR',
          count: 219,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2300',
        },
        isSelected: false,
      },
      {
        title: 'YouTube',
        model: {
          id: '24',
          name: 'YouTube',
          count: 194,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/24',
        },
        isSelected: false,
      },
      {
        title: 'Practice Labs',
        model: {
          id: '2112',
          name: 'Practice Labs',
          count: 171,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/2112',
        },
        isSelected: false,
      },
      {
        title: 'The Ken Blanchard Companies',
        model: {
          id: '3316',
          name: 'The Ken Blanchard Companies',
          count: 116,
          score: 0,
          filter: false,
          baseUrl: 'http://degreedstg.staging.degreed.dev/provider/view/3316',
        },
        isSelected: false,
      },
    ],
  },
  {
    id: 'Duration',
    title: 'Core_Duration',
    subitems: [
      {
        title: '< 5 min',
        model: {
          id: 'LessThan5',
          name: 'LessThan5',
          count: 65720,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '< 10 mins',
        model: {
          id: 'LessThan10',
          name: 'LessThan10',
          count: 88044,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '< 30 mins',
        model: {
          id: 'LessThan30',
          name: 'LessThan30',
          count: 109830,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '< 1 hour',
        model: {
          id: 'LessThan1Hour',
          name: 'LessThan1Hour',
          count: 125187,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '< 4 hours',
        model: {
          id: 'LessThan4Hours',
          name: 'LessThan4Hours',
          count: 168840,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '< 1 day',
        model: {
          id: 'LessThan1Day',
          name: 'LessThan1Day',
          count: 194110,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
      {
        title: '> 1 day',
        model: {
          id: 'GreaterThan1Day',
          name: 'GreaterThan1Day',
          count: 30509,
          score: 0,
          filter: false,
        },
        isSelected: false,
      },
    ],
  },
  {
    id: 'Groups',
    title: 'Core_Groups',
    subitems: [],
  },
];
